type Props = React.SVGAttributes<SVGElement> & {
  iconColor?: string
}

export const LandscapeListIcon = ({
  iconColor = 'currentColor',
  ...props
}: Props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.66667 2H3C2.44772 2 2 2.44772 2 3V5.66667C2 6.21895 2.44772 6.66667 3 6.66667H5.66667C6.21895 6.66667 6.66667 6.21895 6.66667 5.66667V3C6.66667 2.44772 6.21895 2 5.66667 2Z"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: 'none' }}
      />
      <path
        d="M8.66602 3.33337H13.9993M8.66602 5.33337H13.9993"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: 'none' }}
      />
      <path
        d="M5.66667 8.66663H3C2.44772 8.66663 2 9.11434 2 9.66663V12.3333C2 12.8856 2.44772 13.3333 3 13.3333H5.66667C6.21895 13.3333 6.66667 12.8856 6.66667 12.3333V9.66663C6.66667 9.11434 6.21895 8.66663 5.66667 8.66663Z"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: 'none' }}
      />
      <path
        d="M8.66602 10H13.9993M8.66602 12H13.9993"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ fill: 'none' }}
      />
    </svg>
  )
}
